import { combineReducers } from "redux";

function WizardReducer() {
  const countyInitialState = {
    counties: [],
    detail: {},
  };
  const psDetailsInitialState = {
    personalDetails: null,
    supportDetails: null,
    whatToCareNoteFor: null,
  };
  const emergencyPlanInitialState = {
    contacts: [],
    disasterDetails: "",
  };

  const hiDetailsInitialState = {
    diagnosis: null,
    allergies: null,
  };
  const acDetailsInitialState = {
    alertConditions: null,
  };
  const techDetailsInitialState = {
    technologyDetails: null,
  };

  const usersBillingDataInitialState = {
    usersBillingData: null,
  };

  const bulkAssociationsInitialState = {
    careCircleUserType: null,
    careCircleUsers: [],
  };
  const calendarTemplateSpecificDayEventsValidatorState = {
    windows: [...Array(31)].map((_) => Array(24).fill(false)),
    events: [...Array(31)].map((_) => Array(24).fill(false)),
  };

  const wizardData = (state = {}, action) => {
    switch (action.type) {
      case "WIZARD_DATA_INIT":
        return {};
      case "GET_CARE_PLAN_SUCCESS":
        return action.payload;
      case "UPDATE_DOC_LOGS":
        return {
          ...state,
          carePlanDocumentLogs: [action.payload, ...state.carePlanDocumentLogs],
        };
      case "UPDATE_GUARDIAN_NOTES_SUCCESS":
        return {
          ...state,
          guardianNotes: action.payload,
        };
      case "UPDATE_GUARDIAN_NOTES":
        return {
          ...state,
          guardianNotes: action.payload,
        };
      case "UPDATE_CASE_MANAGER_NOTES":
        return {
          ...state,
          caseManagerNotes: action.payload,
        };
      case "UPDATE_SECTION_NOTES_SUCCESS":
        return {
          ...state,
          ...action.payload,
        };
      case "UPDATE_USES_MULTIPLE_LOCATIONS":
        return {
          ...state,
          usesMultipleLocations: action.payload,
        };
      default:
        return state;
    }
  };

  const assignedClient = (state = {}, action) => {
    switch (action.type) {
      case "ASSIGNED_CLIENT_INIT":
        return {};
      case "ASSIGNED_CLIENT_SUCCESS":
        return action.payload;
      case "UPDATE_ASSIGNED_CLIENT":
        return action.payload;
      default:
        return state;
    }
  };

  const visitors = (state = [], action) => {
    switch (action.type) {
      case "VISITORS_INIT":
        return [];
      case "VISITORS_SUCCESS":
        return action.payload;
      case "UPDATE_VISITORS":
        return action.payload;
      default:
        return state;
    }
  };

  const assignedClientProfile = (state = {}, action) => {
    switch (action.type) {
      case "ASSIGNED_CLIENT_PROFILE_INIT":
        return {};
      case "ASSIGNED_CLIENT_PROFILE_SUCCESS":
        return action.payload;
      case "UPDATE_ASSIGNED_CLIENT_PROFILE":
        return action.payload;
      case "UPDATE_TABLET_EVENT_FLAG":
        return {
          ...state,
          profileInfo: {
            ...state.profileInfo,
            tabletEventFlag: action.payload.tabletEventFlag,
          },
        };
      default:
        return state;
    }
  };

  const supportPlanGroupUsers = (state = [], action) => {
    switch (action.type) {
      case "SUPPORT_PLAN_GROUP_USERS_INIT":
        return [];
      case "SUPPORT_PLAN_GROUP_USERS_SUCCESS":
        return action.payload;
      case "UPDATE_SUPPORT_PLAN_GROUP_USERS":
        return action.payload;
      default:
        return state;
    }
  };

  const manager = (state = [], action) => {
    switch (action.type) {
      case "CASE_MANAGERS_INIT":
        return [];
      case "CASE_MANAGERS_SUCCESS":
        return action.payload;
      case "ADD_CASE_MANAGERS_FROM_MODAL":
        return action.payload;
      case "UPDATE_CASE_MANAGERS":
        return action.payload;
      default:
        return state;
    }
  };

  const provider = (state = [], action) => {
    switch (action.type) {
      case "HPC_INIT":
        return [];
      case "HPC_SUCCESS":
        return action.payload;
      case "ADD_HPC_FROM_MODAL":
        return action.payload;
      case "UPDATE_HPC":
        return action.payload;
      default:
        return state;
    }
  };

  const guardian = (state = [], action) => {
    switch (action.type) {
      case "GUARDIANS_INIT":
        return [];
      case "GUARDIANS_SUCCESS":
        return action.payload;
      case "ADD_GUARDIANS_FROM_MODAL":
        return action.payload;
      case "UPDATE_GUARDIANS":
        return action.payload;
      default:
        return state;
    }
  };

  const county = (state = countyInitialState, action) => {
    switch (action.type) {
      case "COUNTY_DETAILS_INIT":
        return {
          counties: [],
          detail: {},
        };
      case "COUNTY_DETAILS_SUCCESS":
        return {
          ...state,
          detail: action.payload,
        };
      case "UPDATE_COUNTY_SUCCESS":
        return {
          ...state,
          detail: action.payload.detail,
          counties: action.payload.counties,
        };
      case "UPDATE_COUNTIES_SUCCESS":
        return {
          ...state,
          counties: action.payload,
        };
      case "GET_COUNTIES_SUCCESS":
        return {
          ...state,
          counties: action.payload,
        };
      case "ADD_COUNTY_SUCCESS":
        return {
          ...state,
          counties: [...state.counties, action.payload.newOrganization],
          detail: action.payload.newDetail,
        };
      default:
        return state;
    }
  };

  const naturalSupport = (state = [], action) => {
    switch (action.type) {
      case "NATURAL_SUPPORT_INIT":
        return [];
      case "NATURAL_SUPPORT_SUCCESS":
        return action.payload;
      case "ADD_NATURAL_SUPPORT_FROM_MODAL":
        return action.payload;
      case "UPDATE_NATURAL_SUPPORT":
        return action.payload;
      default:
        return state;
    }
  };

  const callTree = (state = [], action) => {
    switch (action.type) {
      case "CALL_TREE_INIT":
        return [];
      case "CALL_TREE_SUCCESS":
        return action.payload;
      case "ADD_CALL_TREE_FROM_MODAL":
        return action.payload;
      case "UPDATE_CALL_TREE":
        return action.payload;
      default:
        return state;
    }
  };

  const csr = (state = [], action) => {
    switch (action.type) {
      case "CSR_INIT":
        return [];
      case "CSR_SUCCESS":
        return action.payload;
      case "ADD_CSR_FROM_MODAL":
        return action.payload;
      case "UPDATE_CSR":
        return action.payload;
      default:
        return state;
    }
  };

  const psDetails = (state = psDetailsInitialState, action) => {
    switch (action.type) {
      case "PS_DETAILS_INIT":
        return {
          personalDetails: null,
          supportDetails: null,
          whatToCareNoteFor: null,
        };
      case "PS_DETAILS_SUCCESS":
        return action.payload;
      case "UPDATE_PS_DETAILS":
        return action.payload;
      default:
        return state;
    }
  };

  const emergencyPlan = (state = emergencyPlanInitialState, action) => {
    switch (action.type) {
      case "EMERGENCY_PLAN_INIT":
        return {
          contacts: [],
          disasterDetails: "",
        };
      case "SET_EMERGENCY_PLAN":
        return action.payload;
      case "SET_EMERGENCY_CONTACTS":
        return {
          ...state,
          contacts: action.payload,
        };
      case "UPDATE_EMERGENCY_CONTACTS":
        return {
          ...state,
          contacts: action.payload,
        };
      case "UPDATE_DISASTER_EMERGENCY_PLAN":
        return {
          ...state,
          disasterDetails: action.payload,
        };
      case "UPDATE_EMERGENCY_PLAN":
        return action.payload;
      default:
        return state;
    }
  };

  const cpaActions = (state = [], action) => {
    switch (action.type) {
      case "CPA_ACTIONS_INIT":
        return [];
      case "CPA_ACTIONS_SUCCESS":
        return action.payload;
      case "UPDATE_CPA_ACTIONS":
        return action.payload;
      default:
        return state;
    }
  };

  const cpActionEvents = (state = [], action) => {
    switch (action.type) {
      case "CPA_ACTION_EVENTS_INIT":
        return [];
      case "CPA_ACTION_EVENTS_SUCCESS":
        return action.payload;
      default:
        return state;
    }
  };

  const checklistItems = (state = [], action) => {
    switch (action.type) {
      case "GET_CHECKLIST_ITEMS_INIT":
        return [];
      case "GET_CHECKLIST_ITEMS_SUCCESS":
        return action.payload;
      default:
        return state;
    }
  };

  const checklistTemplates = (state = [], action) => {
    switch (action.type) {
      case "GET_CHECKLIST_TEMPLATES_INIT":
        return [];
      case "GET_CHECKLIST_TEMPLATES_SUCCESS":
        return action.payload;
      case "CLEAR_CHECKLIST_TEMPLATES_INIT":
        return [];
      default:
        return state;
    }
  };

  const hiDetails = (state = hiDetailsInitialState, action) => {
    switch (action.type) {
      case "HI_DETAILS_INIT":
        return {
          allergies: null,
          diagnosis: null,
        };
      case "HI_DETAILS_SUCCESS":
        return action.payload;
      case "UPDATE_HI_DETAILS":
        return action.payload;
      default:
        return state;
    }
  };

  const acDetails = (state = acDetailsInitialState, action) => {
    switch (action.type) {
      case "AC_DETAILS_INIT":
        return {
          alertConditions: null,
        };
      case "AC_DETAILS_SUCCESS":
        return action.payload;
      case "UPDATE_AC_DETAILS":
        return action.payload;
      default:
        return state;
    }
  };

  const techDetails = (state = techDetailsInitialState, action) => {
    switch (action.type) {
      case "TECH_DETAILS_INIT":
        return {
          technologyDetails: null,
        };
      case "TECH_DETAILS_SUCCESS":
        return action.payload;
      case "UPDATE_TECH_DETAILS":
        return action.payload;
      default:
        return state;
    }
  };

  const technologiesList = (state = null, action) => {
    switch (action.type) {
      case "TECHNOLOGIES_LIST_INIT":
        return null;
      case "TECHNOLOGIES_LIST_SUCCESS":
        return action.payload;
      case "UPDATE_TECHNOLOGIES_LIST":
        return action.payload;
      default:
        return state;
    }
  };

  const calendarTemplate = (state = [], action) => {
    switch (action.type) {
      case "CALENDAR_TEMPLATE_INIT":
        return [];
      case "CALENDAR_TEMPLATE_SUCCESS":
        return action.payload;
      case "UPDATE_CALENDAR_TEMPLATE":
        return [...state, ...action.payload];
      case "REMOVE_CALENDAR_EVENT":
        return action.payload;
      case "RESET_CALENDAR_TEMPLATE":
        return action.payload;
      default:
        return state;
    }
  };

  const calendarTemplateSpecificDayEvents = (state = [], action) => {
    switch (action.type) {
      case "CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS_INIT":
        return [];
      case "CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS_SUCCESS":
        return action.payload;
      case "UPDATE_CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS":
        return [...state, ...action.payload];
      case "REMOVE_CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENT":
        return action.payload;
      case "RESET_CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS":
        return calendarTemplateSpecificDayEventsValidatorState;
      default:
        return state;
    }
  };

  const calendarTemplateSpecificDayEventsValidator = (
    state = calendarTemplateSpecificDayEventsValidatorState,
    action,
  ) => {
    switch (action.type) {
      case "CALENDAR_TEMPLATE_SPECIFIC_DAY_VALIDATOR_INIT":
        return {};
      case "CALENDAR_TEMPLATE_SPECIFIC_DAY_VALIDATOR_SUCCESS":
        return action.payload;
      case "UPDATE_CALENDAR_TEMPLATE_SPECIFIC_DAY_VALIDATOR":
        return action.payload;
      case "UPDATE_CALENDAR_TEMPLATE_SPECIFIC_DAY_WINDOWS_VALIDATOR":
        return {
          ...state,
          windows: action.payload,
        };
      case "UPDATE_CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS_VALIDATOR":
        return {
          ...state,
          events: action.payload,
        };
      case "RESET_CALENDAR_TEMPLATE_SPECIFIC_DAY_EVENTS":
        return calendarTemplateSpecificDayEventsValidatorState;
      default:
        return state;
    }
  };

  const bulkAssociations = (state = bulkAssociationsInitialState, action) => {
    switch (action.type) {
      case "BULK_ARR_INIT":
        return {
          careCircleUserType: null,
          careCircleUsers: [],
        };
      case "BULK_ARR_SUCCESS":
        return action.payload;
      default:
        return state;
    }
  };

  const calendarEffectiveDate = (state = null, action) => {
    switch (action.type) {
      case "CALENDAR_DATE_INIT":
        return null;
      case "CALENDAR_DATE_SUCCESS":
        return action.payload
          ? new Date(action.payload.replace("Z", ""))
          : null;
      case "CALENDAR_DATE_UPDATE":
        return new Date(action.payload);
      default:
        return state;
    }
  };

  const schedulerLoadedWeeks = (state = [], action) => {
    switch (action.type) {
      case "SCHEDULER_LOADED_WEEKS_INIT":
        return [];
      case "SCHEDULER_LOADED_WEEKS_SUCCESS":
        return action.payload;
      case "UPDATE_SCHEDULER_LOADED_WEEKS":
        return [...state].concat(action.payload);
      case "REMOVE_SCHEDULER_LOADED_WEEK":
        return action.payload;
      case "EDIT_SCHEDULER_LOADED_WEEKS":
        return action.payload;
      default:
        return state;
    }
  };

  const usersBilling = (state = null, action) => {
    switch (action.type) {
      case "USERS_BILLING_DATA_INIT":
        return null;
      case "USERS_BILLING_DATA_SUCCESS":
        return action.payload;
      case "UPDATE_USERS_BILLING_DATA":
        return action.payload;
      default:
        return state;
    }
  };

  const schedulerTemplate = (state = [], action) => {
    switch (action.type) {
      case "SCHEDULER_TEMPLATE_INIT":
        return [];
      case "SCHEDULER_TEMPLATE_SUCCESS":
        return action.payload;
      case "UPDATE_SCHEDULER_TEMPLATE":
        return [...state, action.payload];
      case "REMOVE_SCHEDULER_EVENT":
        return action.payload;
      case "EDIT_SCHEDULER_TEMPLATE":
        return action.payload;
      default:
        return state;
    }
  };

  const clientSensorsList = (state = null, action) => {
    switch (action.type) {
      case "CLIENT_SENSORS_LIST_INIT":
        return null;
      case "CLIENT_SENSORS_LIST_SUCCESS":
        return action.payload;
      case "UPDATE_CLIENT_SENSORS_LIST":
        return action.payload;
      default:
        return state;
    }
  };

  const predicates = (state = null, action) => {
    switch (action.type) {
      case "PREDICATES_INIT":
        return null;
      case "PREDICATES_SUCCESS":
        return action.payload;
      case "UPDATE_PREDICATES":
        return action.payload;
      default:
        return state;
    }
  };

  const predicateCompositions = (state = null, action) => {
    switch (action.type) {
      case "PREDICATE_COMPOSITIONS_INIT":
        return null;
      case "PREDICATE_COMPOSITIONS_SUCCESS":
        return action.payload;
      case "UPDATE_PREDICATE_COMPOSITIONS":
        return action.payload;
      default:
        return state;
    }
  };

  const acknowledgementLogs = (state = null, action) => {
    switch (action.type) {
      case "ACKNOWLEDGEMENT_LOGS_INIT":
        return null;
      case "ACKNOWLEDGEMENT_LOGS_SUCCESS":
        return action.payload;
      case "UPDATE_ACKNOWLEDGEMENT_LOGS":
        return action.payload;
      default:
        return state;
    }
  };

  const satisfactionScores = (state = [], action) => {
    switch (action.type) {
      case "SATISFACTION_SCORES_INIT":
        return [];
      case "SATISFACTION_SCORES_SUCCESS":
        return action.payload;
      case "UPDATE_SATISFACTION_SCORES":
        return action.payload;
      default:
        return state;
    }
  };

  const calendarTemplateMessageBanner = (
    state = { isVisible: true },
    action,
  ) => {
    switch (action.type) {
      case "CALENDAR_TEMPLATE_MESSAGE_BANNER_INIT":
        return [];
      case "CALENDAR_TEMPLATE_MESSAGE_BANNER_TOGGLE":
        return {
          ...state,
          isVisible: !state.isVisible,
        };
      default:
        return state;
    }
  };

  const callTreeAddresses = (state = [], action) => {
    switch (action.type) {
      case "CALL_TREE_ADDRESSES_INIT":
        return null;
      case "CALL_TREE_ADDRESSES_SUCCESS":
        return action.payload;
      case "UPDATE_CALL_TREE_ADDRESSES":
        return action.payload;
      default:
        return state;
    }
  };

  return combineReducers({
    wizardData,
    assignedClient,
    usersBilling,
    visitors,
    assignedClientProfile,
    supportPlanGroupUsers,
    manager,
    guardian,
    provider,
    county,
    naturalSupport,
    callTree,
    csr,
    psDetails,
    emergencyPlan,
    cpaActions,
    cpActionEvents,
    checklistItems,
    checklistTemplates,
    hiDetails,
    acDetails,
    techDetails,
    calendarTemplate,
    calendarTemplateSpecificDayEvents,
    calendarTemplateSpecificDayEventsValidator,
    schedulerLoadedWeeks,
    schedulerTemplate,
    bulkAssociations,
    calendarEffectiveDate,
    clientSensorsList,
    technologiesList,
    predicates,
    predicateCompositions,
    acknowledgementLogs,
    satisfactionScores,
    calendarTemplateMessageBanner,
    callTreeAddresses,
  });
}

export default WizardReducer();
